<template>
  <div class="card dash-card headercard" style="margin-top:2px; height:710px;">
    <LamboDigitalChecksHeader :dashdata="dashdata" />

    <div class="card-body p-0 m-0">
      <div class="il-table">
        <div class="il-row">
          <div class="il-cell width-20">
            <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('1. Web Check - POL - Check')" :isHeader="true" />
            <titleunderline />

            <div class="dash-card-inner">
              <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('KPI 01')" :noLetterSpacing="true" />
              <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('KPI 02')" :noLetterSpacing="true" />
            </div>
          </div>

          <div class="il-cell width-40">
            <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('2. Web Enquiry Reply')" :isHeader="true" />
            <titleunderline />

            <div class="dash-card-inner">
              <div class="row no-gutters">
                <div class="col-6">
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('KPI 03')" :noLetterSpacing="true" />
                </div>
                <div class="col-6">
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('KPI 04')" :noLetterSpacing="true" />
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('KPI 05')" :noLetterSpacing="true" />
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('KPI 06')" :noLetterSpacing="true" />
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('KPI 07')" :noLetterSpacing="true" />
                </div>
              </div>
              <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('KPI 08')" :noLetterSpacing="true" />
            </div>
          </div>

          <div class="il-cell width-40">
            <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('3. Web Enquiry Offer')" :isHeader="true" />
            <titleunderline />

            <div class="dash-card-inner">
              <div class="row no-gutters">
                <div class="col-6">
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('KPI 09')" :noLetterSpacing="true" />
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('KPI 10')" :noLetterSpacing="true" />
                </div>
                <div class="col-6">
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('KPI 11')" :noLetterSpacing="true" />
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('KPI 12')" :noLetterSpacing="true" />
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('KPI 13')" :noLetterSpacing="true" />
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('KPI 14')" :noLetterSpacing="true" />
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('KPI 15')" :noLetterSpacing="true" />
                  <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('KPI 16')" :noLetterSpacing="true" />
                </div>
                <tableitem :overallByWave="getOverallByWave" :kpi="getKpiByString('KPI 17')" :noLetterSpacing="true" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import performanceitem from './PerformanceItem'
  import tableitem from './TableItem.vue'
  import titleunderline from './TitleUnderline'
  import LamboDigitalChecksHeader from './LamboDigitalChecksHeader'
  import KpiMixin from '@/mixins/lambo/KpiMixin';

  export default {
    components: {
      performanceitem,
      tableitem,
      titleunderline,
      LamboDigitalChecksHeader
    },

    mixins: [ KpiMixin ]
  }
</script>

<style scoped>
  .dash-card >>> .kpitable {
    max-width: 208px;
  }
</style>
